import axiosPost from '../axiosPost';
import { MerchantUsuarioType, UserCredentialsType } from '../../../types/types';
import { AxiosPostBody } from '../../../types/AxiosPost';


export const QR30AceptadorOperacionGet = async (arg: UserCredentialsType, posTransaccionId: number) => {
    const body: AxiosPostBody = {
        "service": "QR30AceptadorOperacionGet",
        "params": {
            posTransaccionId
        }
    }

    const result = await axiosPost<MerchantUsuarioType>('Y', body, arg);
            if(result?.status?.code === 0) {
                return [result.status]
            } else {
                return result.result;
            }
}